import React from 'react';
import { cn } from '@/shadcn/lib/utils';

export const Small = React.forwardRef<HTMLElement, React.ComponentPropsWithoutRef<'small'>>(
  ({ className, ...props }, ref) => <small ref={ref} className={cn('text-sm font-medium leading-none', className)} {...props} />,
);

Small.displayName = 'Small';
